import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const AlignTextTop = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <g>
          <path d="M13.192 1.2c.446 0 .808.317.808.71 0 .358-.304.655-.698.702l-.11.006H2.808C2.362 2.618 2 2.301 2 1.91c0-.359.304-.656.698-.703l.11-.006h10.384zM8.475 4.171l.072.064 5.573 5.573a.71.71 0 0 1-.93 1.066l-.073-.063L8.76 6.452v8.039a.71.71 0 0 1-1.411.096l-.007-.096V6.44L2.96 10.811a.71.71 0 0 1-.93.063l-.073-.064a.71.71 0 0 1-.062-.93l.064-.073 5.587-5.573a.71.71 0 0 1 .93-.063z"/>
        </g>
      </svg>)} {...props}/>));
export default AlignTextTop;
